import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const linkReference: NodeRenderer = (node, children) => (
  <a href={`#${node.data.identifier}`} id={node.data.identifier}>
    {children}
  </a>
)
